import { DefinitionTooltip, RadioButton, RadioButtonGroup, Stack } from '@carbon/react';
import cx from 'clsx';

import { useIsReadonly } from 'core/readonly';
import { MEASUREMENT_SYSTEM, MEASUREMENT_SYSTEM_LABEL } from 'models/measurementSystem';
import ProjectTier from 'shared/components/ProjectTier';
import styles from 'theme/components/aside-quick-view.module.scss';

const AsideQuickView = ({
  isLoading,
  onMeasurementSystemChange,
  measurementSystem,
  title,
  project,
  fullHeight = false,
  withProjectName = false,
  children
}) => {
  const isReadonly = useIsReadonly();

  return (
    <aside className={cx(styles.wrapper, !fullHeight && styles['wrapper--content-height'])}>
      <h4>
        <strong>{title}</strong>
      </h4>
      {withProjectName && (
        <h3>
          <strong>{project?.details.name}</strong>
          {project?.details?.tier != null && (
            <ProjectTier
              tier={project.details.tier}
              isValid={project.details.tierIsValid}
              withTooltip
              size="lg"
              inline
            />
          )}
        </h3>
      )}
      {(project?.details.isFinal || project?.details.isConfidential) && (
        <h4>
          {project?.details.isFinal && <div className={styles.label}>Final Version</div>}
          {project?.details.isConfidential && <div className={styles.label}>Confidential</div>}
        </h4>
      )}
      <Stack gap={3}>
        <p>
          <DefinitionTooltip
            definition="The selected measurement system will apply to areas throughout the project."
            align="bottom-left"
          >
            Measurement System
          </DefinitionTooltip>
        </p>
        <RadioButtonGroup
          name="area-measurement-system"
          valueSelected={measurementSystem}
          onChange={(value) => onMeasurementSystemChange(value)}
          disabled={isLoading || isReadonly}
        >
          {[MEASUREMENT_SYSTEM.imperial, MEASUREMENT_SYSTEM.metric].map((m) => (
            <RadioButton
              key={m}
              labelText={MEASUREMENT_SYSTEM_LABEL[m]}
              value={m}
              id={`measurement-system-${m.toString()}`}
            />
          ))}
        </RadioButtonGroup>
      </Stack>
      {children}
    </aside>
  );
};

export default AsideQuickView;
